import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {Params} from '@angular/router';
import {BaseComponent} from '../../base.component';
import {StringUtil} from '../../../util/string.util';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {DataResponse} from '../../../network/service/data.response';
import {isEqual} from 'lodash';
import {RequestType} from '../../../enums/request.type';
import {strings} from '../../../../value/strings';
import {SessionStorageUtil} from '../../../util/session.storage.util';
import {Config} from '../../../common/config';
import {SelectAdditivesComponent} from '../dialog/select-additives/select-additives.component';
import {DeviceService} from '../../../util/service/device.service';
import {Constant} from '../../../common/constant';
import {DocumentUtil} from '../../../util/document.util';

@Component({
  selector: 'app-service-details-page',
  standalone: false,
  templateUrl: './service-details-page.component.html',
  styleUrl: './service-details-page.component.scss',
})
export class ServiceDetailsPageComponent extends BaseComponent implements OnInit {
  service: any;
  uniqueIdentifier?: string;
  orders?: any = [];
  comments?: any = [];
  @Output() openDrawerRequested = new EventEmitter<void>();
  isMobile?: boolean;
  protected readonly StringUtil = StringUtil;
  protected readonly Config = Config;

  constructor(injector: Injector, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['ServiceSlug'] && params['ServiceSlug'] !== '') {
        this.uniqueIdentifier = params['ServiceSlug'];
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getServices(undefined, undefined, 'ServicePrices,ServicePrices.ServicePriceAdditives,ServicePrices.ServicePriceAdditives.Additive,ServicePrices.ServicePriceAdditives.Attribute,Category', RequestType.ONE, Config.branch.BusinessId, {
      Filter: {
        Values: [{
          Field: 'UniqueIdentifier',
          Type: 'EQ',
          Value: this.uniqueIdentifier
        }]
      }
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.service = res.data;
        this.getOrders();
        this.getComments();
        this.seo();
      }
    });
  }

  getComments(): void {
    this.serviceApi.getComments(undefined, undefined, 'User,Factor,Factor.FactorOrders,Factor.FactorOrders.Order,Factor.FactorOrders.Order.ServicePrice,Factor.FactorOrders.Order.ServicePrice.Service', RequestType.ALL, Config.branch.BusinessId, {
      Filter: {
        Values: [{
          Field: 'ServiceId',
          Type: 'EQ',
          Value: this.service.ServiceId
        }]
      }
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.comments = res.data;
        this.seo();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  getOrders() {
    if (this.hasAccount()) {
      this.serviceApi.getMyOrders(undefined, undefined, 'ServicePrice,ServicePrice.Service,ServicePrice.Service.ServicePrices,ServicePrice.ServicePriceAdditives,ServicePrice.ServicePriceAdditives.Additive,ServicePrice.ServicePriceAdditives.Attribute', RequestType.ALL, Config.branch.BusinessId, {
        Filter: {
          Values: [{
            Field: 'Type',
            Type: 'EQ',
            Value: strings.basket,
          }]
        }
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.orders = res.data;
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    } else {
      let basket: any[] = SessionStorageUtil.loadObject(strings.basket_service_ids, []);
      this.orders = basket;
      Config.basketCount = basket.length;
    }
  }

  getProductAttributePriceCount(servicePriceId: string) {
    let order = this.orders?.filter((order: any) => order.ServicePriceId === servicePriceId);
    let totalCount = 0;
    if (order) {
      for (const element of order) {
        totalCount += (element ? parseInt(element.Count) : 0);
      }
    }
    return totalCount;
  }

  onAddToBasketClicked(service: any, count?: any) {
    this.onServiceClicked({
      Service: service,
      Count: count
    });
  }

  onServiceClicked(object: any) {
    if (object.Service.ServicePrices?.length > 0 && object.Service.ServicePrices[0].ServicePriceAdditives?.length > 0) {
      this.saveOrder(object, object.Service, object.Service.ServicePriceAdditiveIds);
    } else {
      this.saveOrder(object, object.Service);
    }
  }

  saveOrder(object: any, service: any, additives?: any[]) {
    if (this.hasAccount()) {
      this.serviceApi.postOrders({
        ServicePriceId: service.ServicePrices[0]?.ServicePriceId,
        Count: object.Count,
        Type: strings.basket,
        ServicePriceAdditiveIds: additives,
        BranchId: Config.branch.BusinessId
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          if (res.data.dataValues && !res.data.previousDataValues) {
            Config.basketCount++;
          } else if (!res.data.dataValues) {
            Config.basketCount--;
          }
          this.getOrders();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    } else {
      let basket: any[] = SessionStorageUtil.loadObject(strings.basket_service_ids, []);
      let basketServicePrice: any;
      if (additives) {
        basketServicePrice = basket.find((basketServicePrice: any) => {
          return service.ServicePrices[0].ServicePriceId === basketServicePrice.ServicePriceId &&
            isEqual(basketServicePrice.ServicePriceAdditiveIds, additives);
        });
      } else {
        basketServicePrice = basket.find((basketServicePrice: any) => {
          return service.ServicePrices[0].ServicePriceId === basketServicePrice.ServicePriceId;
        });
      }
      if (basketServicePrice) {
        basketServicePrice.Count = object.Count;
      } else {
        let temp = {
          ...service.ServicePrices[0]
        };
        temp.ServicePrice = service.ServicePrices[0];
        temp.ServicePrice.Service = {...object.Service};
        delete temp.ServicePrice.Service.ServicePrices;
        temp.Count = object.Count;
        temp.ServicePriceAdditiveIds = service.ServicePriceAdditiveIds;
        basket.push(temp);
      }
      basket = basket.filter((basketServicePrice: any) => {
        return basketServicePrice.Count !== 0;
      });
      SessionStorageUtil.saveObject(strings.basket_service_ids, basket);
      this.getOrders();
      Config.basketCount = basket.length;
    }
  }

  onProductOrderClicked(value: number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (this.service.ServicePrices[0]?.ServicePriceAdditives?.length > 0) {
      if (value < 0) {
        let order = this.orders?.findLast((order: any) => {
          return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId;
        });
        if (order) {
          let temp = {
            ...order.ServicePrice?.Service
          };
          temp.ServicePrices = [order.ServicePrice];
          temp.ServicePriceAdditiveIds = order.ServicePriceAdditiveIds;
          this.onAddToBasketClicked(temp, ((order?.Count ?? 0) + value));
        }
      } else {
        const dialogRef = this.matDialog.open(SelectAdditivesComponent, {
          width: this.isMobile ? '100%' : '500px',
          height: this.isMobile ? 'auto' : 'auto',
          panelClass: this.isMobile ? 'mobile-dialog-panel' : 'desktop-dialog-panel',
          data: {
            Service: this.service,
            onSubmit: (service: any, additives: any[]) => {
              service.ServicePriceAdditiveIds = additives;
              let order = this.orders?.find((order: any) => {
                return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId &&
                  isEqual(order.ServicePriceAdditiveIds, additives);
              });
              this.onAddToBasketClicked(service, ((order?.Count ?? 0) + value));
              dialogRef.close();
            }
          }
        });
        dialogRef.afterClosed().subscribe(() => {
        });
      }
    } else {
      let order = this.orders?.find((order: any) => {
        return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId;
      });
      if (order) {
        let temp = {
          ...order.ServicePrice?.Service
        };
        temp.ServicePrices = [order.ServicePrice];
        temp.ServicePriceAdditiveIds = order.ServicePriceAdditiveIds;
        this.onAddToBasketClicked(temp, ((order?.Count ?? 0) + value));
      } else {
        this.onAddToBasketClicked(this.service, value);
      }
    }
    this.openDrawerRequested.emit();
  }

  removeHtmlTags(htmlString: string): string {
    return htmlString.replace(/<[^>]*>/g, '');
  }

  seo() {
    this.titleService.setTitle(this.service.Title ?? '');
    // Set Meta Description
    this.metaService.updateTag({
      name: 'description',
      content: this.removeHtmlTags(this.service.Description ?? '')
    });
    this.metaService.updateTag({
      property: 'keywords',
      content: `${this.service.Category?.Title ?? ''} ${this.service.Title ?? ''}`
    });
    // Set Open Graph Tags for Social Media
    this.metaService.updateTag({
      property: 'og:title',
      content: this.service.Title ?? ''
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: this.removeHtmlTags(this.service.Description ?? '')
    });
    if (this.service.Images?.length > 0) {
      this.metaService.updateTag({
        property: 'og:image',
        content: this.formatImage('xx', this.service.Images[0])
      });
    }
    this.metaService.updateTag({
      property: 'og:url',
      content: `${Constant.getDomain()}service-details/${Config.branch.UniqueIdentifier}/${this.service.UniqueIdentifier}`
    });
    // Set Twitter Card Tags
    this.metaService.updateTag({
      name: 'twitter:title',
      content: this.service.Title ?? ''
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content: this.removeHtmlTags(this.service.Description ?? '')
    });
    if (this.service.Images?.length > 0) {
      this.metaService.updateTag({
        name: 'twitter:image',
        content: this.formatImage('xx', this.service.Images[0])
      });
    }
    // Set Canonical Url
    this.metaService.updateTag({
      rel: 'canonical',
      href: `${Constant.getDomain()}service-details/${Config.branch.UniqueIdentifier}/${this.service.UniqueIdentifier}`
    });
    let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    let day = currentDate.getDate() + 1;
    let month = currentDate.getMonth();
    let year = currentDate.getFullYear();
    let ldJSON = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": this.service.Title ?? '',
      "description": this.removeHtmlTags(this.service.Description ?? ''),
      "image": this.service.Images?.length > 0 ? this.formatImage('', this.service.Images[0]) : null,
      "brand": {
        "@type": "Brand",
        "name": this.service.Category?.Title ?? ''
      },
      "offers": this.service.ServicePrices?.map((servicePrice: any) => {
        return {
          "@type": "Offer",
          "price": servicePrice.Price ?? 0,
          "priceCurrency": "IRR",
          "priceValidUntil": (year + "/" + month + "/" + day),
          "availability": servicePrice.MaxCapacity > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
          "url": `${Constant.getDomain()}service-details/${Config.branch.UniqueIdentifier}/${this.service.UniqueIdentifier}`,
          "itemCondition": "https://schema.org/NewCondition"
        };
      }),
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": this.service.Rate ?? 0,
        "reviewCount": this.service.ViewCount ?? 0
      },
      // "shippingDetails": {
      //   "@type": "OfferShippingDetails",
      //   "shippingRate": {
      //     "@type": "MonetaryAmount",
      //     "value": "50000",
      //     "currency": "IRR"
      //   },
      //   "deliveryTime": {
      //     "@type": "ShippingDeliveryTime",
      //     "handlingTime": {
      //       "@type": "QuantitativeValue",
      //       "minValue": "1",
      //       "maxValue": "3",
      //       "unitCode": "DAY"
      //     },
      //     "transitTime": {
      //       "@type": "QuantitativeValue",
      //       "minValue": "1",
      //       "maxValue": "5",
      //       "unitCode": "DAY"
      //     }
      //   }
      // },
      // "hasMerchantReturnPolicy": {
      //   "@type": "MerchantReturnPolicy",
      //   "applicableCountry": "IR",
      //   "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
      //   "merchantReturnDays": 30
      // }
    });
    DocumentUtil.updateElementBody(this.renderer, 'head', 'ld-json', ldJSON);
  }
}
